import React, { useState, useEffect, useRef } from "react";
import { submitReportUsers } from "../Api";

function ReportUsersModal({ match_id, user_id, profile_image, full_name, onClose, onSubmit }) {
    const [content, setContent] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const textareaRef = useRef(null);

    useEffect(() => {
        setIsVisible(true);
        textareaRef.current?.focus();
    }, []);

    const handleSubmit = async () => {
        if (!content.trim()) return;

        try {
            await submitReportUsers(match_id, user_id, content);
            onSubmit();
        } catch (error) {
            console.error("Failed to submit report", error);
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div
            onClick={handleClose}
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: isVisible ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                transition: "background-color 300ms ease",
                color: "#fa0404ff",

            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: "white",
                    padding: "1rem 2rem",
                    borderRadius: 8,
                    minWidth: 320,
                    maxWidth: "90%",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                    transform: isVisible ? "scale(1)" : "scale(0.8)",
                    opacity: isVisible ? 1 : 0,
                    transition: "opacity 300ms ease, transform 300ms ease",
                    willChange: "transform, opacity",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {profile_image && (
                    <img
                        src={profile_image}
                        alt={full_name || "Profile"}
                        style={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginBottom: "0.5rem",
                        }}
                    />
                )}

                {full_name && (
                    <div
                        style={{
                            fontWeight: "700",
                            fontSize: "1.2rem",
                            marginBottom: "1rem",
                            textAlign: "center",
                        }}
                    >
                        {full_name}
                    </div>
                )}

                <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>
                    match_id: {match_id}
                </div>

                <div style={{ marginBottom: "1rem", width: "100%" }}>
                    <label htmlFor="content" style={{ fontWeight: "600" }}>
                        Report Content
                    </label>
                    <textarea
                        id="content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows={5}
                        onKeyDown={handleKeyDown}
                        ref={textareaRef}
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                            marginTop: "0.25rem",
                            boxSizing: "border-box",
                            resize: "vertical",
                        }}
                    />
                </div>

                <button
                    disabled={!content.trim()}
                    onClick={handleSubmit}
                    style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: content.trim() ? "#007bff" : "#a0c4ff",
                        color: "white",
                        border: "none",
                        borderRadius: 4,
                        cursor: content.trim() ? "pointer" : "not-allowed",
                        userSelect: "none",
                        transition: "background-color 200ms ease",
                        alignSelf: "flex-end",
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}

export default ReportUsersModal;
